import requestInstance from '../../utils/instance-utils';

export const getEbpcSkills = (isWhitelisted: boolean) =>
    requestInstance.get('/skills/ebpc', {
        headers: { 'X-Is-Whitelisted': String(isWhitelisted) },
    });
